import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Label,
  Input,
  Spinner,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";

import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import usePersistStoreData from "../../../Components/Hooks/usePersistStoreData";
import { showToast } from "../../../Components/ToastNotification";
import DocumentActionCard from "../../../Components/Common/DocumentActionCard";
import { reKyc_UploadDocumentsRekycThunk } from "../../../slices/thunks";
import Message from "../../../Components/Common/Message";

const DocumentsUpload = ({ setSteps, steps }) => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({ signature: "", bank: "", pan: "" });
  const dispatch = useDispatch();
  const { userData } = usePersistStoreData();
  const token = userData?.token;
  const [signatureFile, setSignatureFile] = useState(null);
  const [bankDocument, setBankDocument] = useState(null);
  const [panDocument, setPanDocument] = useState(null);
  const { reKyc_digio_requestResponseData } = useSelector(
    (state) => state.Re_Kyc_Digio_Request_Response
  );
  const { reKyc_UploadDocumentsRekycLoading } = useSelector(
    (state) => state.Re_Kyc_UploadDocumentsRekyc
  );
  // state to check if bank is verify or not
  const { reKyc_bankVerifyData } = useSelector(
    (state) => state.Re_Kyc_Bank_Verify
  );
  // state to check pan data
  const { reKyc_UpdatePersonalDetailData } =
    useSelector((state) => state.Re_Kyc_Update_Personal_Details);

  const handleDocumentsUpload = () => {
    let newErrors = { signature: "", bank: "", pan: "" };
    let hasError = false;

    if (!signatureFile) {
      newErrors.signature = "Signature is required.";
      hasError = true;
    }
    if (userData?.banks_verified == 0 && !bankDocument) {
      newErrors.bank = "Bank document is required.";
      hasError = true;
    }
    if (
      reKyc_UpdatePersonalDetailData?.is_pan_available !== 1 &&
      userData?.is_pan_available === 0 &&
      !panDocument
    ) {
      newErrors.pan = "PAN document is required.";
      hasError = true;
    }

    setErrors(newErrors);
    if (hasError) return;
    const formData = new FormData();
    formData.append("wet_signature", signatureFile);
    if (bankDocument) {
      formData.append("bank_proof", bankDocument);
    }

    if (panDocument) {
      formData.append("pan", panDocument);
    }
    dispatch(reKyc_UploadDocumentsRekycThunk({ body: formData, token }))
      .then((res) => {
        if (res?.payload?.code == 200) {
          showToast(res?.payload?.message, "success");
          setSteps(steps + 1);
          setSignatureFile(null);
          setBankDocument(null);
          setPanDocument(null);
        } else {
          showToast(res?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToast(err, "error");
      });
  };

  return (
    <React.Fragment>
      <div className="">
      {userData?.rekcy_appication_status === "rejected" && (
          <div className=" ">
            <Message
              message={userData?.rekcy_appication_sreason}
              color="danger"
              mb={4}
            />
          </div>
      )}
        { (
    reKyc_UpdatePersonalDetailData?.is_pan_available !== 1 && 
    userData?.is_pan_available === 0
  ) && (
          <>
            <DocumentActionCard
              text="Upload PAN"
              iconType="upload"
              onClick={(file) => setPanDocument(file)}
              fileType="pdf"
              hasError={!!errors.pan}
            />
            {errors.pan && (
              <p className="text-danger fs-12 pb-3 m-0">{errors.pan}</p>
            )}
          </>
        )}
        {(userData?.banks_verified == 0 ||
          reKyc_bankVerifyData?.is_verified === false) && (
          <>
            <DocumentActionCard
              text="Upload Bank Document"
              iconType="upload"
              onClick={(file) => setBankDocument(file)}
              fileType="pdf"
              hasError={!!errors.bank}
            />
            {errors.bank && (
              <p className="text-danger fs-12 pb-3-0 m-0">{errors.bank}</p>
            )}
          </>
        )}

        <DocumentActionCard
          text="Upload Signature"
          iconType="upload"
          onClick={(file) => setSignatureFile(file)}
          fileType="image"
          hasError={!!errors.signature}
        />
        {errors.signature && (
          <p className="text-danger fs-12 pb-3 m-0">{errors.signature}</p>
        )}

        <Col lg={12}>
          <div className="hstack gap-2 justify-content-end">
            <button
              type="button"
              className="btn btn-soft-secondary"
              onClick={() => {
                setSteps(steps - 1);
              }}
            >
              Prev
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                handleDocumentsUpload();
                // setSteps(steps + 1);
              }}
              disabled={reKyc_UploadDocumentsRekycLoading}
              style={{
                minWidth: "60px",
              }}
            >
              {reKyc_UploadDocumentsRekycLoading ? (
                <Spinner size="sm" />
              ) : (
                "Next"
              )}
            </button>
          </div>
        </Col>
      </div>
    </React.Fragment>
  );
};

export default DocumentsUpload;
